export default "__VITE_ASSET__cad8d90b__"